import dayjs from "dayjs";
import "dayjs/locale/sv";
import i18n, { type TFunction } from "i18next";
import { initReactI18next } from "react-i18next";
import settingsEN from "./en/accountSettingsEN.json";
import chartEN from "./en/chartEN.json";
import commonEN from "./en/commonsEN.json";
import dashboardEN from "./en/dashboardEN.json";
import libraryEN from "./en/libraryEN.json";
import modalEN from "./en/modalEN.json";
import sidebarEN from "./en/sidebarEN.json";
import toastEN from "./en/toastsEN.json";
import settingsSV from "./sv/accountSettingsSV.json";
import chartSV from "./sv/chartSV.json";
import commonSV from "./sv/commonsSV.json";
import dashboardSV from "./sv/dashboardSV.json";
import librarySV from "./sv/librarySV.json";
import modalSV from "./sv/modalSV.json";
import sidebarSV from "./sv/sidebarSV.json";
import toastSV from "./sv/toastsSV.json";
import passwordEN from "./en/passwordEN.json";
import passwordSV from "./sv/passwordSV.json";
import validationsEN from "./en/validationsEN.json";
import validationsSV from "./sv/validationsSV.json";
import onboardingEN from "./en/onboardingEN.json";
import onboardingSV from "./sv/onboardingSV.json";
import quizEN from "./en/quizEN.json";
import quizSV from "./sv/quizSV.json";

export const LANGUAGE_STORAGE_KEY = "language";

export const languages = {
  english: {
    code: "en",
  },
  swedish: {
    code: "sv",
  },
} as const;

export function getLangLabels(t: TFunction): Record<string, string> {
  return {
    en: t(($) => $.commons.languages.en),
    sv: t(($) => $.commons.languages.sv),
  };
}

const initLang = () =>
  localStorage.getItem(LANGUAGE_STORAGE_KEY) ?? languages.english.code;

export const resources = {
  en: {
    translation: {
      ...libraryEN,
      ...dashboardEN,
      ...chartEN,
      ...settingsEN,
      ...onboardingEN,
      ...sidebarEN,
      ...toastEN,
      ...modalEN,
      ...passwordEN,
      ...validationsEN,
      ...quizEN,
      ...commonEN,
    },
  },
  sv: {
    translation: {
      ...librarySV,
      ...dashboardSV,
      ...chartSV,
      ...settingsSV,
      ...sidebarSV,
      ...onboardingSV,
      ...toastSV,
      ...modalSV,
      ...passwordSV,
      ...validationsSV,
      ...quizSV,
      ...commonSV,
    },
  },
};

// formatDate formats in the dayjs global locale
i18n.on("languageChanged", (language) => {
  dayjs.locale(language);
});

void i18n.use(initReactI18next).init({
  resources,
  lng: initLang(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
